import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import ChevrondownIcon from 'icons/Chevrondown.icon';

import './AgreementPageNavigation.styles.scss';

type AgreementPageNavigationProps = {
  className?: string;
  currentPage: number;
  pageCount: number;
  onPageChange: (page: number) => void;
};

const AgreementPageNavigation: React.FC<AgreementPageNavigationProps> = (
  props,
) => {
  const { className, currentPage, pageCount, onPageChange } = props;

  const { t } = useTranslation();

  const classes = classNames('agreement-page-navigation', className);

  return (
    <nav className={classes}>
      <Button
        type="button"
        variant="icon"
        icon={ChevrondownIcon}
        className="agreement-page-navigation__prev"
        aria-label={t('previousPage')}
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
      />
      <span>
        {t('pageXOfY', { current: currentPage, total: pageCount })}
      </span>
      <Button
        type="button"
        variant="icon"
        icon={ChevrondownIcon}
        className="agreement-page-navigation__next"
        aria-label={t('nextPage')}
        disabled={currentPage >= pageCount}
        onClick={() => onPageChange(currentPage + 1)}
      />
    </nav>
  );
};

export default AgreementPageNavigation;
